import React from 'react'
import { useForm, Controller } from 'react-hook-form'

import { Box, Select, Grid, Button, TextField } from '@the-platform-group/component-library'

const SELECT_BY_OPTIONS = {
  name: {
    key: 'name',
    label: 'Name',
  },
  email: {
    key: 'email',
    label: 'Email',
  },
  linkedin_url: {
    key: 'linkedin_url',
    label: 'LinkedIn URL',
  },
}

const RocketReachSearchFilters = ({ handleSearch }) => {
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      searchBy: '',
      searchTerm: '',
      searchKeywords: '',
    },
  })

  const searchBy = watch('searchBy')
  const searchTerm = watch('searchTerm')

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleSubmit(handleSearch)()
    }
  }

  return (
    <Box component="form" sx={{ width: '100%', p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <Box
            component="form"
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              outline: '1px solid',
              outlineColor: 'grey.400',
              outlineOffset: '-1px',
              borderRadius: 1,
              '&:hover': {
                outlineColor: 'secondary.dark',
              },
              '&:focus-within': {
                outlineColor: 'primary.main',
                outlineWidth: '2px',
              },
            }}
          >
            <Controller
              name="searchBy"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  variant="outlined"
                  label="Search by"
                  placeholder="Select"
                  margin="none"
                  options={Object.values(SELECT_BY_OPTIONS).map(option => ({
                    value: option.key,
                    label: option.label,
                  }))}
                  sx={{
                    minWidth: '210px',
                    '& fieldset': {
                      border: 'unset',
                      borderRight: '1px solid',
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      borderColor: 'grey.400',
                    },
                    '& .MuiFormLabel-root': {
                      backgroundColor: 'white',
                      px: 1,
                    },
                    // Apply hover styles when parent Box is hovered
                    '.MuiBox-root:hover &': {
                      '& fieldset': {
                        borderColor: 'secondary.dark',
                      },
                    },
                    // Apply focus styles when parent Box has focus-within
                    '.MuiBox-root:focus-within &': {
                      '& fieldset': {
                        borderColor: 'primary.main',
                        borderWidth: '2px',
                      },
                    },
                  }}
                />
              )}
            />
            <Controller
              name="searchTerm"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  id="contactNameOrEmail"
                  disabled={!searchBy}
                  label={`Contact ${searchBy.split('_').join(' ') ||
                    'name, email or linkedin url'}`}
                  variant="outlined"
                  margin="none"
                  onKeyDown={handleKeyDown}
                  sx={{
                    width: '100%',
                    '& fieldset': {
                      border: 'unset',
                    },
                    '& .MuiFormLabel-root:not(.Mui-disabled)': {
                      backgroundColor: 'white',
                      px: 1,
                    },
                  }}
                />
              )}
            />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Controller
            name="searchKeywords"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                disabled={!(searchBy && searchTerm)}
                label="Keywords"
                placeholder="Keywords"
                variant="outlined"
                sx={{ width: '100%' }}
              />
            )}
          />
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(handleSearch)}
            disabled={!Boolean(searchBy && searchTerm)}
            type="submit"
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default RocketReachSearchFilters
